import { motion } from "framer-motion";
import { AlbumGrid } from "./album-grid";
import { PublicCategory } from "@/app/lib/api/public";

interface CategoriesPageProps {
  title: string;
  description: string;
  items: PublicCategory[] | undefined;
  baseUrl: string;
  isLoading?: boolean;
}

export function CategoriesPage({ 
  title, 
  description, 
  items, 
  baseUrl,
  isLoading = false 
}: CategoriesPageProps) {
  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="text-center">Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <div className="absolute inset-0 z-0 overflow-hidden">
        <div className="absolute inset-0 bg-grid-black/[0.02] bg-[size:20px_20px]" />
      </div>

      <div className="container relative z-[2] mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center space-y-2 mb-8"
        >
          <h1 className="text-2xl font-bold bg-gradient-to-r from-orange-500 to-orange-600 bg-clip-text text-transparent">
            {title}
          </h1>
          <p className="text-sm text-gray-600">{description}</p>
        </motion.div>

        {items && items.length > 0 ? (
          <AlbumGrid items={items} baseUrl={baseUrl} />
        ) : (
          <div className="text-center">Hiç albüm bulunamadı.</div>
        )}

      </div>
    </div>
  );
} 